import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

const UpcomingEvents = () => {
    const data = useStaticQuery(graphql`
            query UpcomingEventQuery {
                allMarkdownRemark(sort: {fields: frontmatter___eventDate, order: DESC}, limit: 5, filter: {fileAbsolutePath: {regex: "\\/events/"}}) {
                edges {
                    node {
                    frontmatter {
                        eventDate(formatString: "Do MMMM")
                        title
                    }
                    fields {
                        slug
                    }
                    }
                }
                }
            }
        `
    )
    return (
    <div className="container">
        <div className="row">
            <div className="col"></div>
            <div className="col-10 col-md-8 color-four event-block-text">
                <h1 className="text-center mt-3">Upcoming Events</h1>
                <br />
                <ul className="list-unstyled pl-3">
                    {data.allMarkdownRemark.edges.map(({ node }) =>
                        <Link to={node.fields.slug}>
                            <li className="event-block-text">{node.frontmatter.eventDate}: {node.frontmatter.title}</li>
                        </Link>
                    )}
                </ul>
                
                <br />
                <Link to="/events" className="white-text"><p className="pl-3">See more events.</p></Link>
            </div>
            <div className="col"></div>
        </div>
    </div>
    )
}

export default UpcomingEvents

